const Winston = require('winston')
const Transport = require('winston-transport')
const util = require('util')

const { format } = Winston
const { combine, colorize, prettyPrint, printf, timestamp } = format

// Limit 8 FG & 8 BG Colors
const COLOR_DICTIONARY = {
  Reset: '\x1b[0m',
  Bright: '\x1b[1m',
  Dim: '\x1b[2m',
  Underscore: '\x1b[4m',
  Blink: '\x1b[5m',
  Reverse: '\x1b[7m',
  Hidden: '\x1b[8m',
  // Forground
  FgBlack: '\x1b[30m',
  FgRed: '\x1b[31m',
  FgGreen: '\x1b[32m',
  FgYellow: '\x1b[33m',
  FgBlue: '\x1b[34m',
  FgMagenta: '\x1b[35m',
  FgCyan: '\x1b[36m',
  FgWhite: '\x1b[37m',
  // Background
  BgBlack: '\x1b[40m',
  BgRed: '\x1b[41m',
  BgGreen: '\x1b[42m',
  BgYellow: '\x1b[43m',
  BgBlue: '\x1b[44m',
  BgMagenta: '\x1b[45m',
  BgCyan: '\x1b[46m',
  BgWhite: '\x1b[47m',
}

const COLORS = {
  silly: COLOR_DICTIONARY.FgMagenta,
  info: COLOR_DICTIONARY.FgCyan,
  error: COLOR_DICTIONARY.FgRed,
  warn: COLOR_DICTIONARY.FgYellow,
  verbose: COLOR_DICTIONARY.BgYellow,
  debug: COLOR_DICTIONARY.FgMagenta,
}

const jsonCleanUP = (value) => {
  const replaceErrors = (key, value) => {
    if (value instanceof Error) {
      const error = {}
      Object.getOwnPropertyNames(value).forEach((propName) => {
        error[propName] = value[propName]
      })
      return error
    }
    return value
  }
  return value
}

const transformData = (info) => {
  const args = [info.message, ...(info[Symbol.for('splat')] || [])]
  // Overwrite Message
  info.message = args
  // Loop over and set VALUES
  const msg = args
    .map((arg) => {
      if (typeof arg === 'object' && !Array.isArray(arg)) {
        return JSON.stringify(arg, jsonCleanUP, 2)
      }
      return arg
    })
    .join(' ')

  info[Symbol.for('message')] = `${info[Symbol.for('level')]}: ${msg}${
    info.stack ? ' ' + info.stack : ''
  }`

  return info
}

class DeveloperTransport extends Transport {
  constructor(options) {
    super({
      format: combine(
        { transform: transformData },
        timestamp({
          format: 'MM/DD/YYYY HH:mm:ss',
        }),
        format.splat(),
        format.simple()
      ),
    })
  }

  log = (info, callback) => {
    setImmediate(() => {
      this.emit('logged', info)
    })
    const { timestamp, level, message } = info

    // We are gonna write LOGIC to figure out TYPE of DATA
    const messageTypes = message.reduce((types, item) => {
      return [...types, typeof item]
    }, [])

    /*
    message ( isArray ) accepts: String, Numbers, Boolean
    message => [ 'Name: Developer', 'Age is', 600, 'Working:', false ]
    result => "Name: Developer Age is 600 Working: false""
    */

    const isArray =
      messageTypes.filter((item) => {
        return item !== 'object'
      }).length === message.length
    if (isArray) {
      console.log(
        `\n${COLOR_DICTIONARY.Underscore}${COLOR_DICTIONARY.BgMagenta}${timestamp}${COLOR_DICTIONARY.Reset} | ${COLORS[level]}Logger.${level}${COLOR_DICTIONARY.Reset}`,
        `\n${message.join(' ')}`,
        `\n${COLOR_DICTIONARY.Reset}`
      )
    } else {
      // Create an ARRAY of Formatted Strings
      const messageFormated = messageTypes.reduce((result, type, position) => {
        const messageItem = message[position]
        // Handle String, Number, Boolean, etc...
        if (type !== 'object') {
          return [...result, `${messageItem}`]
        }
        // Handle Arrays
        const isArray = Array.isArray(messageItem)
        // Pretty Print JSON.stringify Object
        const formattedMessageItem = util.inspect(messageItem, {
          showHidden: isArray ? false : true,
          colorize: true,
          colors: true,
          compact: true,
          depth: Infinity,
        })
        // Add NEWLINE for ITEMS after 0 => /n
        return [
          ...result,
          `${position === 0 ? '' : '\n'}${formattedMessageItem}${
            position === messageTypes.length - 1 ? '' : '\n'
          }`,
        ]
      }, [])

      console.log(
        `\n${COLOR_DICTIONARY.Underscore}${COLOR_DICTIONARY.BgMagenta}${timestamp}${COLOR_DICTIONARY.Reset} | ${COLORS[level]}Logger.${level}${COLOR_DICTIONARY.Reset}`,
        `\n${messageFormated.join(' ')}`,
        `\n${COLOR_DICTIONARY.Reset}`
      )
    }

    if (callback) {
      callback()
    }
  }
}

module.exports = DeveloperTransport
